export default "__VITE_ASSET__679c9e7e__"